/**
 * src/lib/consent.js — sự đồng ý của người dùng cho đo lường.
 *
 * Nguyên tắc: KHÔNG tải Google Analytics, Microsoft Clarity hay ghi nhật ký
 * hành trình cho tới khi người dùng bấm "Đồng ý". Từ chối là mặc định an toàn:
 * website vẫn chạy đầy đủ, chỉ là không đo lường.
 *
 * Lựa chọn lưu trong localStorage của trình duyệt (không phải cookie, không
 * gửi đi đâu). Đổi phiên bản KHOA khi chính sách thay đổi đáng kể để hỏi lại.
 */
import { useEffect, useState } from 'react';

export const KHOA = 'fvn-dong-y-v1';
/** Trình duyệt của quản trị viên: bật để lượt truy cập của chính mình không bị đếm. */
export const KHOA_BO_QUA = 'fvn-khong-dem';
const SU_KIEN = 'fvn-dong-y-doi';

function coTrinhDuyet() { return typeof window !== 'undefined' && typeof localStorage !== 'undefined'; }

/** 'dong-y' | 'tu-choi' | null (chưa chọn). */
export function docDongY() {
  if (!coTrinhDuyet()) return null;
  try {
    const raw = JSON.parse(localStorage.getItem(KHOA) || 'null');
    return raw?.chon === 'dong-y' || raw?.chon === 'tu-choi' ? raw.chon : null;
  } catch { return null; }
}

export const daDongY = () => docDongY() === 'dong-y';

export function ghiDongY(chon) {
  if (!coTrinhDuyet()) return;
  const truoc = docDongY();
  try { localStorage.setItem(KHOA, JSON.stringify({ chon, ngay: new Date().toISOString().slice(0, 10) })); } catch { /* chế độ riêng tư */ }
  window.dispatchEvent(new CustomEvent(SU_KIEN, { detail: { chon, truoc } }));
}

/** Mở lại hộp chọn (link "Cài đặt cookie" ở chân trang). */
export function moLaiHopChon() {
  if (!coTrinhDuyet()) return;
  window.dispatchEvent(new CustomEvent(SU_KIEN, { detail: { moLai: true } }));
}

export function theoDoiDongY(fn) {
  if (!coTrinhDuyet()) return () => {};
  const h = (e) => fn(e.detail || {});
  window.addEventListener(SU_KIEN, h);
  return () => window.removeEventListener(SU_KIEN, h);
}

export function boQuaTrinhDuyetNay() {
  if (!coTrinhDuyet()) return false;
  try { return localStorage.getItem(KHOA_BO_QUA) === '1'; } catch { return false; }
}

export function datBoQua(bat) {
  if (!coTrinhDuyet()) return;
  try { bat ? localStorage.setItem(KHOA_BO_QUA, '1') : localStorage.removeItem(KHOA_BO_QUA); } catch { /* bỏ qua */ }
}

/** Hook: trạng thái đồng ý, cập nhật khi người dùng đổi lựa chọn. Luôn null khi render phía máy chủ. */
export function useDongY() {
  const [chon, setChon] = useState(null);
  useEffect(() => {
    setChon(docDongY());
    return theoDoiDongY((d) => { if (d.chon) setChon(d.chon); });
  }, []);
  return chon;
}

/** Xoá cookie của GA (_ga, _ga_*) và Clarity (_clck, _clsk) khi người dùng rút lại đồng ý. */
export function xoaCookieDoLuong() {
  if (typeof document === 'undefined') return;
  const ten = document.cookie.split(';').map((c) => c.split('=')[0].trim())
    .filter((n) => /^(_ga|_gid|_gat|_clck|_clsk|CLID|MUID)/.test(n));
  const host = window.location.hostname;
  const mien = ['', host, '.' + host, '.' + host.split('.').slice(-2).join('.')];
  for (const n of ten) for (const d of mien) {
    document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? '; domain=' + d : ''}`;
  }
}
